import {
    mapActions,
    mapGetters,
    mapState
} from 'vuex';
import debounce from 'lodash/debounce';
export const specialtyMixins = {
    data() {
        return {
            params: {
                query: {
                    $limit: 100,
                    $sort: {
                        rank: -1
                    }
                }
            },
        }
    },
    computed: {
        ...mapState('specialty', {
            cdbLoading: 'isFindPending'
        }),
        ...mapGetters('specialty', {
            findCdbInStore: 'find',
            getCdb: 'get'
        }),

        specialties() {
            return this.findCdbInStore(this.params).data;
        },
    },
    watch: {
        query: debounce(function (newVal) {
            this.queryItems();
        }, 400),
        parentId: debounce(function (newVal) {
            this.queryItems();
        }, 400),
    },
    methods: {
        ...mapActions('specialty', ['find', 'get']),
        ...mapActions('icd', {
            findIcd: 'find'
        }),

        queryItems() {
            if (this.query) {
                this.params.query.$or = [{
                    label: {
                        $regex: this.query,
                        $options: "i"
                    }
                }];
            } else {
                delete this.params.query.$or;
            }

            if (this.parentId) {
                this.params.query.parentId = this.parentId;
            } else {
                this.params.query.parentId = null;
                if (this.query) {
                    delete this.params.query.parentId;
                }
            }

            this.find(this.params);
        },
    }

}
